<template>
    <div class='app-container'>

        <el-card>
           <!-- <div slot="header">
               <router-link  :to="{ path:'/deployNew', query: { callback: fetchData }}">
                   <el-button type="primary">创建</el-button>
               </router-link>
           </div> -->

            <!-- 排班表格 -->
            <el-table v-loading='tableLoading' :data="deployinfo" border type='index'>

                <!-- id -->
                <el-table-column label="id" prop="id" width='60px'></el-table-column>

                <!-- 提交人 -->
                <el-table-column label="提交人" prop="user_cn_name"></el-table-column>

                <!-- 应用 -->
                <el-table-column label="应用" prop="app" width='160px'></el-table-column>

                <!-- 上线单标题 -->
                <el-table-column label="上线单标题" prop="title"></el-table-column>

                <!-- 环境 -->
                <el-table-column label="环境">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.env | tableVal(env) }}
                        </span>
                    </template>
                </el-table-column>

                <!-- 发布的分支/tag -->
                <el-table-column label="发布的分支/tag" prop="branch"></el-table-column>

                <!-- 部署状态 -->
                <el-table-column label="部署状态" prop="deploy_status">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.deploy_status | tableVal(build) }}
                        </span>
                    </template>
                </el-table-column>

                <!-- 审批状态 -->
                <el-table-column label="审批状态">
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.work_status | tableVal(approval) }}
                        </span>
                    </template>
                </el-table-column>
                
                <!-- 操作 -->
                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">

                        <router-link :to='{path: "/deployLine", query:{ ind: scope.row.id }}'>
                            <el-button type='text'>控制台页面</el-button>
                        </router-link>

                        <router-link  :to='{path: "/approval", query:{ deployId: scope.row.id, callback: fetchData }}'>//v-w-role="'cicdCxjcWdspSpan'"
                            <el-button type='text'>审批</el-button>
                        </router-link>

                    </template>
                </el-table-column>

            </el-table>

             <!-- 分页器 -->
            <Pagination 
                v-show="total>0" 
                :total="total" 
                :page.sync="listQuery.page_num" 
                :limit.sync="listQuery.page_size"
                @pagination="fetchData">
            </Pagination>

        </el-card>
    </div>
</template>

<script>
    import services from './cicd.services'
    import Pagination from '../../components/Pagination'
    import { setInterval, clearInterval } from 'timers'

    export default {
        components: { Pagination },

        data() {
            return {
                searchRequery: {
                    start_time: [],
                    end_time: []
                },
                total: 0,
                tableLoading: true,
                listQuery: {
                    page_num: 1,
                    page_size: 10
                },
                deployinfo: [],
                search_criteria: {},
                timer: null,
                params: {}
            }
        },

        computed: {
            dictionary() {
                return this.$store.state.dictionary2
            },
            build() {
                return this.dictionary.build
            },
            env() {
                return this.dictionary.env
            },
            approval() {
                return this.dictionary.approval
            }
        },

        mounted() {
            this.timer = setInterval(() => {
                let params = {
                    ...this.params,
                    pageIndex: this.listQuery.page_num,
                    pageSize: this.listQuery.page_size,
                }
                this.fetchData(null, params);
            }, 2000)
            this.fetchData();
            services.deploySearch().then(
                res => this.search_criteria = { ...res },
                err => this.$message.error(err.message)
            )
        },
        
        methods:{

            // 请求
            fetchData(content, params) {
                if (content) {
                    params = {
                        ...params,
                        page_num: content.page,
                        page_size: content.limit
                    }
                }
                services.apiApproval(params)
                    .then(res => {
                            this.tableLoading = false
                            this.deployinfo = res.data
                            this.total = res.total
                            this.listQuery.page_num = res.page_num
                        })
                    .catch(err => this.$message.error(err.message))
            },
            
            // 搜索
            Search() { 
                this.params = {
                    ...this.searchRequery,
                    start_time_start: this.searchRequery.start_time[0],
                    start_time_stop: this.searchRequery.start_time[1],
                    end_time_start: this.searchRequery.end_time[0],
                    end_time_stop: this.searchRequery.end_time[1]
                }
                this.fetchData(null, this.params)
            },
            
            // 取消
            Cancel() {
                this.searchRequery = {
                    start_time: [],
                    end_time: []
                }
            },
        },

        destroyed() {
            clearInterval(this.timer)
        },
    }
</script>

<style lang="scss" scoped>
</style>
